import { Button } from '@yellowcard/components-library-vue3';
import { defineComponent, onBeforeMount, ref } from 'vue';
import { storeToRefs } from 'pinia';
import router from '@/router';
import useTransactionsStore from '@/store/modules/transactions';
import { usePaymentStore } from '@/store/modules/payment';
import { PaymentTypes } from '@/types/payment';
export default defineComponent({
    name: 'MinipayViewAddress',
    props: {},
    components: {
        Button,
    },
    setup() {
        const paymentsStore = usePaymentStore();
        const { currentStep: paymentCurrentStep } = storeToRefs(paymentsStore);
        const transactionStore = useTransactionsStore();
        const { selectedCrypto, loading } = storeToRefs(transactionStore);
        const backPath = ref();
        onBeforeMount(() => {
            const backUrl = router.options.history.state.back;
            const route = router.resolve({ path: `${backUrl}` });
            backPath.value = route.path;
        });
        const onKeyPress = () => {
            console.log();
        };
        function viewAddress() {
            paymentCurrentStep.value = PaymentTypes.SellPaymentSteps.PAYMENT_3;
        }
        async function cancelTransaction() {
            loading.value = true;
            try {
                await transactionStore.cancelPayment();
                paymentCurrentStep.value = PaymentTypes.SellPaymentSteps.PAYMENT_7;
                loading.value = false;
            }
            catch {
                console.error('error occured while marking transaction as failed');
                loading.value = false;
            }
        }
        function goBack() {
            paymentCurrentStep.value = PaymentTypes.SellPaymentSteps.PAYMENT_5;
        }
        return {
            onKeyPress,
            viewAddress,
            cancelTransaction,
            goBack,
            selectedCrypto,
            loading,
        };
    },
});
